<template>
  <div class="banner-upload">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--页面标题-->
      <div class="common-form">Banner图片上传</div>

      <el-form-item label="Banner图片" :label-width="formLabelWidth">
        <div
          class="param-img-item"
          :key="index"
          v-for="(banner, index) in form.bannerList"
        >
          <div class="delete-box">
            <i class="el-icon-delete-solid" @click="deleteBanner(index)"></i>
          </div>
          <div class="pic">
            <img
              v-img-url="banner.imgUrl"
              alt=""
              @click="selectImage(banner, 'imgUrl', index)"
            />
          </div>
          <p class="tc gray9">
            建议尺寸比例750x360 像素，多个图片请保持尺寸一致
          </p>
          <div class="d-s-c">
            <div class="url-box flex-1">
              <span class="key-name">跳转地址：</span>
              <el-input
                placeholder="请选择跳转地址"
                :value="banner.name + banner.linkUrl"
                disabled
              ></el-input>
            </div>
            <div class="url-box ml10">
              <el-button type="primary" @click="changeLink(index)"
                >选择链接</el-button
              >
            </div>
          </div>
        </div>

        <div class="d-c-c">
          <el-button @click="addBanner">添加一个Banner图片</el-button>
        </div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading"
          >提交</el-button
        >
      </div>
    </el-form>

    <!--上传图片组件-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      @returnImgs="returnImgsFunc"
    ></Upload>

    <!--链接设置组件-->
    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink
    >
  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
import Upload from "@/components/file/Upload";
import Setlink from "@/components/setlink/Setlink";

export default {
  components: {
    Upload,
    Setlink,
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        bannerList: [],
      },
      /*左边长度*/
      formLabelWidth: "150px",
      loading: false,
      /*是否上传图片*/
      isupload: false,
      /*是否选择链接*/
      is_linkset: false,
      currentIndex: null,
      currentField: null,
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.bannerDetail({}, true)
        .then((data) => {
          let vars = data.data;
          if (vars.bannerList && vars.bannerList.length > 0) {
            self.form.bannerList = vars.bannerList;
          } else {
            // 如果没有数据，初始化一个空的banner
            self.form.bannerList = [
              {
                imgUrl: "",
                linkUrl: "",
                name: "",
              },
            ];
          }
        })
        .catch((error) => {});
    },

    /*添加banner*/
    addBanner() {
      this.form.bannerList.push({
        imgUrl: "",
        linkUrl: "",
        name: "",
      });
    },

    /*删除banner*/
    deleteBanner(index) {
      if (this.form.bannerList.length > 1) {
        this.form.bannerList.splice(index, 1);
      } else {
        this.$message.warning("至少保留一个Banner图片");
      }
    },

    /*选择图片*/
    selectImage(banner, field, index) {
      this.currentIndex = index;
      this.currentField = field;
      this.isupload = true;
    },

    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0 && this.currentIndex !== null) {
        this.form.bannerList[this.currentIndex].imgUrl = e[0].file_path;
        // 如果需要保存文件ID，可以在这里添加
        // this.form.bannerList[this.currentIndex].image_id = e[0].file_id;
      }
      this.isupload = false;
      this.currentIndex = null;
      this.currentField = null;
    },

    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.currentIndex = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e && this.currentIndex !== null) {
        this.form.bannerList[this.currentIndex].linkUrl = e.url;
        this.form.bannerList[this.currentIndex].name =
          "链接到" + " " + e.type + " " + e.name;
      }
      this.currentIndex = null;
    },

    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;

      // 验证所有banner是否都有图片
      let hasEmptyImage = false;
      self.form.bannerList.forEach((banner, index) => {
        if (!banner.imgUrl) {
          hasEmptyImage = true;
          self.$message.warning(`第${index + 1}个Banner图片不能为空`);
        }
      });

      if (hasEmptyImage) {
        self.loading = false;
        return;
      }

      let params = this.form;
      SettingApi.editBanner(params, true)
        .then((data) => {
          self.loading = false;
          self.$message({
            message: "恭喜你，Banner图片设置成功",
            type: "success",
          });
        })
        .catch((error) => {
          self.loading = false;
        });
    },
  },
};
</script>

<style>
.banner-upload {
  padding: 20px;
}

.param-img-item {
  position: relative;
  border: 1px solid #eee;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
}

.delete-box {
  position: absolute;
  top: 10px;
  right: 10px;
}

.delete-box i {
  font-size: 18px;
  color: #f56c6c;
  cursor: pointer;
}

.delete-box i:hover {
  color: #f78989;
}

.pic {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.pic img {
  width: 300px;
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #eee;
  cursor: pointer;
}

.pic img:hover {
  border-color: #409eff;
}

.tc {
  text-align: center;
}

.gray9 {
  color: #999;
  font-size: 12px;
  margin-bottom: 15px;
}

.d-s-c {
  display: flex;
  align-items: center;
}

.flex-1 {
  flex: 1;
}

.ml10 {
  margin-left: 10px;
}

.url-box {
  display: flex;
  align-items: center;
}

.key-name {
  min-width: 80px;
  font-size: 14px;
  color: #606266;
}

.d-c-c {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.common-form {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.common-button-wrapper {
  padding-left: 150px;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/product/setting/bannar.vue